var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_1753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4999 -8.79052e-06C40.1149 -8.79052e-06 20.8378 3.89849 4.37865 12.377L1.82202 13.68V16.5863C1.82202 34.0589 2.15043 80.6855 54.0881 111.545L56.4999 113L58.9118 111.545C110.849 80.6855 111.178 34.0589 111.178 16.5863V13.7189L108.639 12.3947C92.381 3.8773 72.8849 -0.00354004 56.4999 -0.00354004V-8.79052e-06ZM56.4999 9.47433C70.5155 9.47433 87.5079 13.0585 101.576 19.8279C101.538 38.1304 99.6095 74.1774 56.4999 101.414C13.3904 74.1774 11.4412 38.1304 11.4235 19.8279C25.7145 13.0444 42.4844 9.47433 56.4999 9.47433ZM80.2052 35.6797C78.9728 35.7186 77.9276 36.4884 77.3378 37.0781L52.0117 63.3612L42.5197 51.9941C38.0315 46.7926 31.873 50.8182 30.4569 51.754L52.4743 77.3202L82.5429 36.5979C81.917 35.995 81.0776 35.6649 80.2088 35.6797H80.2052Z",
    fill: "#235379"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_1753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuard);
export default __webpack_public_path__ + "static/media/guard.8ca7760c597db893be2dc9896453fbfe.svg";
export { ForwardRef as ReactComponent };